<div *ngIf="banner" class="banner-display">
  <div *ngIf="isList" class="banner-display__image">
    <img [src]="banner"/>
  </div>
  <div *ngIf="!isList" class="banner-display__image">
    <img [src]="banner"/>
  </div>
</div>
